(function() {
	'use strict';
	angular.module('app.leanProjects')
		.directive('resizeLeandnaGrid', resizeLeandnaGrid);
	
	resizeLeandnaGrid.$inject = ['$window', '$timeout', '$rootScope', 'oldNavMargin', 'oldNavMarginCollapsed'];
	function resizeLeandnaGrid($window, $timeout, $rootScope, $experiments, oldNavMargin, oldNavMarginCollapsed) {
		return {
			link: link
		};
		
		function link(scope, element, attr) {
			var embeddedBodyOffsetWhenOpen = oldNavMargin;
			var embeddedBodyOffsetWhenClosed = oldNavMarginCollapsed;
			var w = angular.element($window);
			jQuery(window).off('resize');
			w.off('resize');
			w.bind('resize', function() {
				resize();
				scope.$apply();
			});
			
			function resize() {
				
				//SET HEIGHT
				var navHeight = jQuery('.nav.navbar-nav').innerHeight();
				var padding = parseInt(jQuery('.embeddedBody').css('padding-top')) * 2;
				var titleHeight = jQuery('.newPageTitle').innerHeight();
				var filterHeight = jQuery('.filtersContainer').innerHeight();
				var buttonsHeight = jQuery('.buttonsContainer').innerHeight();
				var searchMessageHeight = jQuery('.search-message-row').innerHeight();
				var pagingHeight = jQuery('.refreshIcon').length ? 32 : 0;
				var hasEndOfLifeBanner = jQuery('.browserIE11EndOfLifeBanner.show').length !== 0;
				if (hasEndOfLifeBanner) {
					navHeight += 60;
				}
				titleHeight = titleHeight ? titleHeight : 0;
				buttonsHeight = buttonsHeight ? buttonsHeight : 0;
				filterHeight = filterHeight ? filterHeight : 0;
				searchMessageHeight = searchMessageHeight ? searchMessageHeight : 0;
				var newHeight = jQuery(window).height() - navHeight - padding - titleHeight - filterHeight - buttonsHeight - searchMessageHeight - pagingHeight - 8;
				newHeight -= 4;
				jQuery(element).css('height', newHeight + 'px');
				
				//SET WIDTH
				var navExists = jQuery('.sidebarCollapsible').length != 0;
				var navOpen = jQuery('.sidebarCollapsible.sidebarCollapsed').length == 0;				
				var navOffset = 13;
				if (navExists && navOpen) {
					navOffset = 184; 
				}
				navOffset += 4;
				var bOffset = scope.navProps.hideSubNav ? embeddedBodyOffsetWhenClosed : embeddedBodyOffsetWhenOpen;	
				jQuery('.embeddedBody').css('margin-left', bOffset);
				var wWidth = jQuery(window).width();
				jQuery('.embeddedBody').innerWidth(wWidth - bOffset);
				var paddingOffset = 32;
				jQuery(element).css('width', (jQuery(window).width() - paddingOffset - navOffset) + 'px');
			}
			
			function init() {
				var hbCont = jQuery('#handlebarContainer').length;
				var supplierPortal = globalConfig.user.role === 'Supplier';
				if (globalConfig && globalConfig.factory) {
					jQuery('#handlebarContainer').bind('leftNavChanged', function() {
						resize();
					});	
					jQuery('#navigation').bind('leftNavChanged', function() {
						resize();
					});	
					resize();					
				} else {
					$timeout(function() {
						init();
					}, 10);
				}
			}		
			
			$timeout(function() { init(); });
		}
	}
})();
